import React from "react";

const Header = () => (
  // TODO: use theme instead of inline styling
  <div className="jumbotron page-header" style={{ borderBottom: "1px solid #dedede" }}>
    <a href="/">
      <div className="container">
        <span className="logo" />
        <span>
          <h2>Online Claim Forms</h2>
        </span>
      </div>
    </a>
  </div>
);

export default Header;
